module.exports = __webpack_public_path__ + "img/sol2.8d62481a.png";